module.exports = __webpack_public_path__ + "static/img/black_x.677e372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black_x.png
// module id = bn3I
// module chunks = 79